import { Link } from 'react-router-dom';
import { siteStats } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stunning%20cinematic%20wide%20illustration%20of%20a%20magical%20library%20filled%20with%20floating%20manga%20pages%20and%20colorful%20comic%20panels%2C%20warm%20golden%20light%20streaming%20through%20stained%20glass%20windows%2C%20ethereal%20atmosphere%2C%20fantasy%20art%20style%2C%20rich%20amber%20and%20crimson%20tones%2C%20dreamy%20and%20immersive%20composition&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="奇妙漫画 - 海量漫画免费阅读"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Gradient Overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-black/40"></div>

      {/* Content */}
      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-300 text-sm font-medium mb-6">
            <i className="ri-sparkling-2-line"></i>
            <span>海量韩漫 · 日漫 · 国漫 免费全集在线看</span>
          </div>

          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            奇妙漫画
            <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-normal mt-2 text-white/90">
              你的掌上漫画图书馆
            </span>
          </h1>

          <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-10 leading-relaxed">
            汇集海量韩漫、日漫、国漫类型，热门推荐漫画免费全集在线看，支持下拉式连续阅读，
            手机流畅滚动体验，完结长篇漫画一网打尽，追更连载最新话。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
            <Link
              to="/category"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-base rounded-full transition-all duration-200 hover:scale-105 whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-compass-3-line"></i>
              开始探索
            </Link>
            <Link
              to="/category?filter=hot"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/15 hover:bg-white/25 text-white font-semibold text-base rounded-full backdrop-blur-sm transition-all duration-200 hover:scale-105 whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-fire-line"></i>
              热门推荐
            </Link>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
            {[
              { value: `${(siteStats.totalComics / 10000).toFixed(1)}万+`, label: '漫画资源', icon: 'ri-book-2-line' },
              { value: `${(siteStats.totalChapters / 10000).toFixed(1)}万+`, label: '漫画章节', icon: 'ri-file-list-2-line' },
              { value: `${(siteStats.dailyVisitors / 10000).toFixed(1)}万+`, label: '日活跃用户', icon: 'ri-user-line' },
              { value: `${(siteStats.registeredUsers / 10000).toFixed(1)}万+`, label: '注册用户', icon: 'ri-group-line' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="w-10 h-10 mx-auto mb-2 flex items-center justify-center rounded-full bg-white/10">
                  <i className={`${stat.icon} text-lg text-primary-300`}></i>
                </div>
                <div className="text-xl md:text-2xl font-bold text-white font-heading">{stat.value}</div>
                <div className="text-xs md:text-sm text-white/60 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-12 rounded-full border-2 border-white/30 flex items-start justify-center pt-2">
          <div className="w-1.5 h-3 rounded-full bg-white/60 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}